module.exports = __webpack_public_path__ + "media/img/corporate/basic-0b72ce4bf9403519eb041a510f15a4fd.svg";